import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProviders } from "./context";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //new react version 18.2 empty app template uses React.StrictMode, but it duplicates calls to backend (calls that are created in effects)
  // <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
